import React, { useEffect, useState } from "react";
import { Layout, IconHeader, Modal } from "components";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "../style.scss";
import { YEAR, LANGUAGES, ValidateData, INDEX } from "constants/appointment";

// import { validateNRIC, generateYearWithNRIC } from "utils/nric";

import { getAppointment } from "services/api-service";

import { batch, useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import {
  changeEnquiryId,
  changeAge,
  changeLanguage,
  changeService,
  changeMobile,
  changeNric
} from "redux/appointment";
import { changePreviousRouteName, clearAppointmentBooking } from "redux/appointmentBooking";

import { DEFAULT_ROUTE, SERVICE_CHANNEL } from "constants/route";
import { BackButton, NextButton, DropDown } from "components/CommonUI";

const ZERO = 0;

export default function Appointment() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const { AGE_INDEX, LANGUAGE_INDEX, OTHER_MAIN_SERVICE_INDEX } = INDEX;

  const { service, age, language } = useSelector((state) => state.appointment);
  const { icon, mainId, displayText, isCrps } = useSelector((state) => state.services);

  const [validated, setValidated] = useState(false);
  const [mainServices, setMainServices] = useState([]);
  const [validateErrors, setValidateErrors] = useState([]);

  const [isOpenModal, setIsOpenModal] = useState(false);

  // const [bornYears, setBornYears] = useState([]);

  const onChangeMainService = (e) => dispatch(changeService(e.target.value));
  // const onChangeAge = (e) => dispatch(changeAge(e.target.value));
  const onChangeLanguage = (e) => dispatch(changeLanguage(e.target.value));

  useEffect(() => {
    if (_.isEmpty(displayText)) {
      navigate(DEFAULT_ROUTE);
      return;
    }
    // setBornYears([{ id: null, text: "Select" }, ...YEAR()]);
    // setBornYears(YEAR());
    dispatch(changeAge("1970"));
  }, []);

  console.log("age", age);

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    const validateErrors = ValidateData(age, language, isCrps);
    setValidateErrors(validateErrors);

    (!e.currentTarget.checkValidity() || validateErrors.length === ZERO) && e.stopPropagation();

    setValidated(true);

    if (validateErrors.length !== ZERO) return;
    dispatch(changePreviousRouteName(pathname));
    navigate(SERVICE_CHANNEL);
  };

  const goHome = () => navigate(DEFAULT_ROUTE);

  const getAppointmentData = async () => {
    batch(() => {
      dispatch(clearAppointmentBooking());
    });
    const response = await getAppointment();
    const data = response.data.data;

    if (!data) return;

    dispatch(changeEnquiryId(data.enquiryNames[0].id));
    setMainServices(data.mainServices);
  };

  const enquiryValues = [
    { id: "", text: "None" },
    ...mainServices
      .filter(({ id }) => id !== Number(mainId))
      .map(({ id, web_disp_text: displayText }) => ({
        id,
        text: displayText
      }))
  ];

  const languageValues = LANGUAGES.map(({ id, language }) => ({
    id,
    text: language
  }));

  useEffect(() => getAppointmentData(), []);

  const onConfirm = () => setIsOpenModal(true);

  const onHideModal = () => setIsOpenModal(false);

  const body = (
    <div className="center">
      <h3>User Data</h3>
      <p>Your filling data will be deleted.</p>
    </div>
  );

  const footer = (
    <div>
      <Button
        className="btn left-button cmp-button pbs-style--primary rounded-pill me-3"
        onClick={onHideModal}>
        No
      </Button>
      <Button className="btn cmp-button pbs-style--primary rounded-pill" onClick={goHome}>
        Yes
      </Button>
    </div>
  );

  return (
    <Layout subHeader={"How can we help?"}>
      <Form className="form-box row" noValidate validated={validated} onSubmit={handleOnSubmit}>
        <IconHeader icon={icon} title={displayText} />
        <div></div>
        <div className="sub-header-label-x px-4" style={{ marginTop: 15, textAlign: "center" }}>
          To help us serve you better, please answer these questions
        </div>

        <div className="p-3  col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4 mt-4">
          <div>
            <DropDown
              label="My language preference is"
              items={languageValues}
              value={language}
              onChange={onChangeLanguage}
            />
          </div>
          <div className="mt-20">
            <DropDown
              label="I would also like to enquire about"
              items={enquiryValues}
              value={Number(service) || ""}
              onChange={onChangeMainService}
            />
          </div>
          {/*{!isCrps && (*/}
          {/*  <div className="mt-20">*/}
          {/*    <DropDown*/}
          {/*      label="I was born in the year of"*/}
          {/*      items={bornYears}*/}
          {/*      value={Number(age)}*/}
          {/*      onChange={onChangeAge}*/}
          {/*      isInvalid={validated && (age === null || age === "")}*/}
          {/*      errorMessage={validateErrors[AGE_INDEX]}*/}
          {/*    />*/}
          {/* </div>*/}
          {/*)}*/}
        </div>

        {/* <div className="form-footer flex-md-row flex-column-reverse justify-content-md-between justify-content-start align-items-md-center align-items-end"> */}
        <div className="form-footer flex-sm-row flex-column-reverse justify-content-sm-between justify-content-start align-items-sm-center align-items-end">
          {/* <HomeButton onClick={onConfirm} /> */}
          <BackButton />

          <div className="mobile-s-10" />
          <NextButton type="submit" />
        </div>
      </Form>

      <Modal
        isOpen={isOpenModal}
        onHide={onHideModal}
        body={body}
        footer={footer}
        closeButton={true}
      />
    </Layout>
  );
}
